import formatDate from 'ember-intl/helpers/format-date'
import type { TemplateOnlyComponent } from '@ember/component/template-only'
import type { BlogPostEntries, BlogPostEntry } from 'teacher-ui-client/subscription-type/blog/index/route.ts'
import { LinkTo } from '@ember/routing'

interface BlogPostsArgs {
  model: BlogPostEntries
}

interface BlogPostEntryArgs {
  post: BlogPostEntry
}

const BlogPostEntry: TemplateOnlyComponent<BlogPostEntryArgs> = <template>
  <LinkTo class="rounded-md border px-4 py-2 text-inherit" @route="subscription-type.blog.post" @model={{@post.sys.id}}>
    <div class="mb-4 flex justify-between">
      <h2>{{@post.fields.title}}</h2>
      <span>
        {{formatDate @post.sys.updatedAt}}
      </span>
    </div>
    <p class="p-2">
      {{@post.fields.summary}}
    </p>
  </LinkTo>
</template>

export const BlogPosts: TemplateOnlyComponent<BlogPostsArgs> = <template>
  <div class="mx-auto flex w-1/2 flex-col gap-y-2 pt-10">
    {{#each @model.items as |post|}}
      <BlogPostEntry @post={{post}} />
    {{/each}}
  </div>
</template>
